import type { CSSProperties } from 'react';

import { TWO_COLUMN_GRID } from '../../dashboards/primitives/two-column-grid';

export const COLUMN: CSSProperties = { display: 'flex', flexDirection: 'column', gap: 14 };

export const TWO_COLUMNS: CSSProperties = TWO_COLUMN_GRID;

export const NOTE: CSSProperties = {
  fontSize: 10.5,
  color: 'var(--nb-subtle)',
  lineHeight: 1.5,
  margin: 0,
};

/** Props every required control carries so it is announced as required. */
export function requiredProps(error: string | undefined) {
  return { 'aria-required': true, 'aria-invalid': error ? true : undefined } as const;
}
